<template>
  <div class="home-page-main">
    <!-- Use new workpackages layout -->
    <template v-if="useNewWorkpackagesPageLayout">
      <work-packages-new
        heading="home.templateHeading"
        :filtered-workpackages="masterWorkpackages"
        :sort-desc="false"
        :allow-new="false"
        :search-workpackages="false"
        e2e-slug="panelTemplateWPNew"
      />

      <work-packages-new
        heading="home.activeHeading"
        :filtered-workpackages="[...mockedActiveWorkpackages, ...activeWorkpackages]"
        :sort-desc="false"
        :allow-new="true"
        :allow-copy="true"
        e2e-slug="panelActiveWPNew"
      />

      <work-packages-new
        heading="home.archivedHeading"
        :filtered-workpackages="[...mockedArchivedWorkpackages, ...archivedWorkpackages]"
        :sort-desc="true"
        :allow-new="false"
        :allow-copy="true"
        :expanded="false"
        e2e-slug="panelArchivedWPNew"
        @expand="getInactiveWorkpackages()"
      />
    </template>

    <!-- Old workpackages layout -->
    <template v-else>
      <work-packages
        heading="home.templateHeading"
        :filtered-workpackages="masterWorkpackages"
        :sort-desc="false"
        :allow-new="false"
        :search-workpackages="false"
        e2e-slug="panelTemplateWP"
      />

      <work-packages
        ref="activeWorkpackages"
        heading="home.activeHeading"
        :filtered-workpackages="[...mockedActiveWorkpackages, ...activeWorkpackages]"
        :sort-desc="false"
        :allow-new="true"
        :allow-copy="true"
        e2e-slug="panelActiveWP"
      />

      <work-packages
        ref="archivedWorkpackages"
        heading="home.archivedHeading"
        :filtered-workpackages="[...mockedArchivedWorkpackages, ...archivedWorkpackages]"
        :sort-desc="true"
        :allow-new="false"
        :allow-copy="true"
        :expanded="false"
        e2e-slug="panelArchivedWP"
        @expand="getInactiveWorkpackages()"
      />
    </template>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { isEmpty, filter, has } from 'lodash';
import { enableAOExtracts, useNewWorkpackagesPage } from '@enums/feature-flags';
import featureFlagsMixin from '../../mixins/featureFlags';

export default {
  mixins: [featureFlagsMixin],
  async beforeRouteLeave(to, from, next) {
    // if workpackage descriptions are being edited and left in invalid state, refetch from db
    // these cannot be run in parallel because they mutate the same state.
    if (
      this.$refs.activeWorkpackages &&
      this.$refs.activeWorkpackages.hasInvalidWorkpackageDescription()
    ) {
      await this.fetchWorkpackages({ params: { wpActive: true } });
    }
    if (
      this.$refs.archivedWorkpackages &&
      this.$refs.archivedWorkpackages.hasInvalidWorkpackageDescription()
    ) {
      await this.fetchWorkpackages({ params: { wpActive: false } });
    }

    return next();
  },

  computed: {
    ...mapState('workpackages', ['workpackages']),
    ...mapGetters('workpackages', [
      'masterWorkpackages',
      'activeWorkpackages',
      'mockedActiveWorkpackages',
      'archivedWorkpackages',
      'mockedArchivedWorkpackages',
      'hasSelectedWorkpackage',
    ]),
    useNewWorkpackagesPageLayout() {
      return this.isFeatureFlagEnabled(useNewWorkpackagesPage);
    },
  },

  async created() {
    const workpackageIds = await this.getActiveWorkpackages();
    const params = { workpackageIds };

    const promises = [
      this.fetchHierarchiesForWorkpackages({ params }),
      // Disabled as inefficient, will revisit in future PR
      // this.getPriceChangeData({ params }),
    ];

    if (this.isFeatureFlagEnabled(enableAOExtracts)) {
      promises.push(this.fetchAOExtracts());
    }

    await Promise.all(promises);
  },

  methods: {
    ...mapActions('workpackages', ['fetchWorkpackages', 'getPriceChangeData', 'fetchAOExtracts']),
    ...mapActions('hierarchy', ['fetchHierarchiesForWorkpackages']),

    async getActiveWorkpackages() {
      return this.fetchWorkpackages({ params: { wpActive: true } });
    },

    async getInactiveWorkpackages() {
      if (isEmpty(filter(this.archivedWorkpackages, wp => !has(wp, 'mocked')))) {
        const workpackageIds = await this.fetchWorkpackages({ params: { wpActive: false } });
        const params = {
          workpackageIds,
        };
        await Promise.all([
          this.fetchHierarchiesForWorkpackages({ params }),
          // Disabled as inefficient, will revisit in future PR
          // this.getPriceChangeData({ params }),
        ]);
      }
    },
  },
};
</script>
